import type { IUserDomain, UserDomainStatus } from '@/entities/domain.entity';
import { getDomainStatusLabel } from '@/entities/domain.entity';
import { cn } from '@/lib/utils';
import { AlertCircleIcon, CheckCircleIcon, ClockIcon } from 'lucide-react';

const STATUS_CONFIG: Record<
	UserDomainStatus,
	{ icon: typeof ClockIcon; className: string; pulse?: boolean }
> = {
	waiting_dns: { icon: ClockIcon, className: 'text-chart-5', pulse: true },
	online: { icon: CheckCircleIcon, className: 'text-chart-2' },
	error: { icon: AlertCircleIcon, className: 'text-destructive' },
};

interface DomainStatusBadgeProps {
	status: UserDomainStatus;
	className?: string;
}

export default function DomainStatusBadge({ status, className }: DomainStatusBadgeProps) {
	const config = STATUS_CONFIG[status];
	const StatusIcon = config.icon;

	return (
		<span
			className={cn(
				'inline-flex items-center gap-1 rounded-full border border-border bg-background/80 px-2 py-0.5 text-xs font-medium',
				config.className,
				config.pulse && 'animate-pulse',
				className,
			)}
		>
			<StatusIcon size={12} className={config.pulse ? 'animate-spin' : undefined} />
			{getDomainStatusLabel(status)}
		</span>
	);
}

interface DomainStatusBadgeFromDomainProps {
	domain: IUserDomain;
	className?: string;
}

export function DomainStatusBadgeFromDomain({ domain, className }: DomainStatusBadgeFromDomainProps) {
	return <DomainStatusBadge status={domain.status} className={className} />;
}
